import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

import { logger } from '@client/utils/logger.util';
import { getEnv } from '@common/utils';

const env = import.meta.env;

const firebaseConfig = {
  apiKey: getEnv('VITE_FIREBASE_API_KEY', { env, logger }) as string,
  authDomain: getEnv('VITE_FIREBASE_AUTH_DOMAIN', { env, logger }) as string,
  projectId: getEnv('VITE_FIREBASE_PROJECT_ID', { env, logger }) as string,
  storageBucket: getEnv('VITE_FIREBASE_STORAGE_BUCKET', {
    env,
    logger,
  }) as string,
  messagingSenderId: getEnv('VITE_FIREBASE_MESSAGING_SENDER_ID', {
    env,
    logger,
  }) as string,
  measurementId: getEnv('VITE_FIREBASE_MEASUREMENT_ID', {
    env,
    logger,
  }) as string,
  appId: getEnv('VITE_FIREBASE_APP_ID', { env, logger }) as string,
};

const firebaseApp = initializeApp(firebaseConfig);
const firebaseAuth = getAuth(firebaseApp);
const firebaseDb = getFirestore(firebaseApp);
const firebaseAnalytics = import.meta.env.PROD ? getAnalytics(firebaseApp) : null;
const firebaseStorage = getStorage(
  firebaseApp,
  `gs://${firebaseConfig.storageBucket}`,
);

export {
  firebaseApp,
  firebaseAuth,
  firebaseDb,
  firebaseAnalytics,
  firebaseStorage,
};
